import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_V_L, ModuleFE_Thunderstorm, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { actionSubTypeLabelMap, DBDef_Action } from '@app/pathway-shared';
import { Component_EditorHeader, viewMode_Edit, viewMode_View } from '@app/styles';
import { SearchableItem_OrderGroup } from '../Page_OrderEditor/consts.js';
import { __stringify } from '@nu-art/ts-common';
import './Editor_OrderGroup.scss';
import { Component_SwitchView } from '@nu-art/permissions-frontend/ui/Component_SwitchView';
import { DefaultEditor_InputText, DefaultEditor_InputText_Optional } from '@app/styles/frontend/ui-manager/ui-components';
import { Dropdown_Subtype } from '../shared-components/DropDown_Subtype.js';
import { ICONS } from '@app/styles';
import { ModuleFE_Action, ModuleFE_OrderGroup } from '../../_entity.js';
import { Component_TagEditor, Q_SortableList, VariableWrapper } from '@app/hcs-frontend';
import { DropDown_Action } from '../../_entity/action/ui-components.js';
import { Component_TagGroups } from '@app/hcs-frontend/tag';
const RenderKey_Edit = 'edit';
const RenderKey_View = 'view';
export class Editor_OrderGroup extends ComponentSync {
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        state.editable = nextProps.editable;
        state.editMode = !state.editable.item._id ? true : (this.state?.editMode ?? false);
        return state;
    }
    // ######################## Logic ########################
    getViewMode = () => this.state.editMode ? viewMode_Edit : viewMode_View;
    getItemActions = () => {
        return [{
                label: 'Edit Order Group',
                action: async () => this.setState({ editMode: true }),
            }, {
                label: 'Delete Order Group',
                action: async () => {
                    await this.state.editable.delete();
                    this.props.deselect?.();
                }
            }, {
                label: 'Export JSON',
                action: async () => {
                    const item = this.state.editable.item;
                    ModuleFE_Thunderstorm.downloadFile({
                        fileName: `OrderGroup - ${item.name}`,
                        mimeType: 'application/json',
                        content: __stringify(item, true)
                    });
                }
            }];
    };
    getEditModeActions = () => {
        const actions = [];
        //Actions for existing item
        if (this.state.editable.item._id)
            actions.push({
                label: 'Done',
                action: async () => this.setState({ editMode: false }),
            });
        //Actions for new item
        else {
            if (this.props.deselect)
                actions.push({
                    label: 'Cancel',
                    action: async () => {
                        return this.props.deselect();
                    },
                });
            actions.push({
                label: 'Save',
                action: async () => {
                    await this.state.editable.save();
                },
            });
        }
        return actions;
    };
    // ######################## Render ########################
    render() {
        return _jsxs(LL_V_L, { id: 'editor__order-group', children: [this.renderHeader(), this.renderBody()] });
    }
    renderHeader = () => {
        return _jsx(Component_EditorHeader, { editable: this.state.editable, searchItem: SearchableItem_OrderGroup, editMode: this.state.editMode, itemActions: this.getItemActions(), editModeActions: this.getEditModeActions() });
    };
    renderBody = () => {
        return _jsxs(LL_V_L, { className: 'editor__order-group__body', children: [this.renderEditor_Name(), this.renderEditor_Label(), this.renderEditor_Items(), this.renderEditor_SubType(), this.renderEditor_Tags()] });
    };
    // ######################## Render - Editors ########################
    renderEditor_Name = () => {
        const editable = this.state.editable;
        const orderName = editable.item.name ?? '-';
        return _jsx(TS_PropRenderer.Vertical, { label: 'Name', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    {
                        key: viewMode_View,
                        renderer: () => _jsx("div", { onClick: () => ModuleFE_Thunderstorm.copyToClipboard(orderName), className: 'editor__value', children: orderName })
                    },
                    { key: viewMode_Edit, renderer: () => _jsx(DefaultEditor_InputText, { editable: editable, prop: 'name' }) }
                ] }) });
    };
    renderEditor_Label = () => {
        const editable = this.state.editable;
        return _jsx(TS_PropRenderer.Vertical, { label: 'Label', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    { key: viewMode_View, renderer: () => _jsx("div", { className: 'editor__value', children: editable.item?.label ?? '-' }) },
                    { key: viewMode_Edit, renderer: () => _jsx(DefaultEditor_InputText_Optional, { editable: editable, prop: 'label' }) }
                ] }) });
    };
    renderEditor_Items = () => {
        const editable = this.state.editable;
        const pointers = editable.editProp('items', []);
        const existingIds = pointers.item.map(pointer => pointer.id);
        return _jsxs(TS_PropRenderer.Vertical, { label: 'Items', children: [_jsx(Q_SortableList, { disabled: !this.state.editMode, items: pointers.item ?? [], onChange: pointers => editable.updateObj({ items: pointers }), itemRenderer: (pointer, index) => {
                        return this.renderEditor_Item(pointer, () => {
                            pointers.removeArrayItem(index);
                        });
                    } }), this.state.editMode && _jsx(DropDown_Action.selectable, { queryFilter: item => !existingIds.includes(item._id), onSelected: order => {
                        pointers.updateArrayAt({ id: order._id, dbKey: DBDef_Action.dbKey });
                    } })] });
    };
    renderEditor_Item = (pointer, onDelete) => {
        const order = ModuleFE_Action.cache.unique(pointer.id);
        return _jsxs(_Fragment, { children: [this.state.editMode && _jsx(ICONS.x.component, { onClick: onDelete }), order?.name ?? 'N/A'] });
    };
    renderEditor_SubType = () => {
        const editable = this.state.editable;
        return _jsx(_Fragment, { children: _jsx(TS_PropRenderer.Vertical, { label: 'Sub Type', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                        {
                            key: RenderKey_View, renderer: () => _jsx("div", { className: 'editor__value', children: actionSubTypeLabelMap[editable.item.subType] })
                        },
                        {
                            key: RenderKey_Edit,
                            renderer: () => _jsx(Dropdown_Subtype, { editable: editable, prop: 'subType', onSelected: async (subType) => {
                                    await editable.updateObj({ subType });
                                }, showErrorTooltip: true })
                        },
                    ] }) }) });
    };
    renderEditor_Tags = () => {
        const editable = this.state.editable;
        const order = ModuleFE_OrderGroup.cache.unique(editable?.item._id);
        const uiTagGroups = VariableWrapper.dbTagsToUI(this.state.editable.get('tagGroups'));
        return _jsx(_Fragment, { children: _jsx(TS_PropRenderer.Vertical, { label: 'Tags', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                        {
                            key: RenderKey_View, renderer: () => _jsx("div", { className: 'editor__value', children: _jsx(Component_TagGroups, { tagGroups: order?.tagGroups }) })
                        },
                        {
                            key: RenderKey_Edit,
                            renderer: () => _jsx(Component_TagEditor, { tags: uiTagGroups, mandatoryRootTag: true, groupTagFilter: () => true, singleTagFilter: (tag, groupTag) => tag.tagIds[0] === groupTag._id, onChange: async () => {
                                    const tagGroups = VariableWrapper.getTagsForDB(uiTagGroups);
                                    await this.state.editable.updateObj({ tagGroups });
                                } })
                        },
                    ] }) }) });
    };
}
//# sourceMappingURL=Editor_OrderGroup.js.map